import { createFeatureSelector, createSelector } from "@ngrx/store";
import { systemFormFeatureKey } from "./system-form.reducer";

export const selectSystemFormState = createFeatureSelector(systemFormFeatureKey);

export const selectSystemForm = createSelector(
  selectSystemFormState,
  (state: any) => state
);